import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ILinksSlice {
	affiliateLink: string;
	shortLink: string;
	isLoading: boolean;
	isSuccess: boolean;
	subIds: Record<string, string>;
}

const initialState: ILinksSlice = {
	affiliateLink: '',
	shortLink: '',
	isLoading: false,
	isSuccess: false,
	subIds: { '1': '' },
};

export const linksSlice = createSlice({
	name: 'linksSlice',
	initialState,
	reducers: {
		setAffiliateLink: (state, action: PayloadAction<string>) => {
			state.affiliateLink = action.payload;
		},
		setShortLink: (state, action: PayloadAction<string>) => {
			state.shortLink = action.payload;
		},
		setIsLoading: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload;
		},
		setIsSuccess: (state, action: PayloadAction<boolean>) => {
			state.isSuccess = action.payload;
		},
		setSubIds: (state, action: PayloadAction<Record<string, string>>) => {
			state.subIds = action.payload;
		},
	},
});

export default linksSlice.reducer;
export const { setIsLoading, setIsSuccess, setShortLink, setAffiliateLink, setSubIds } = linksSlice.actions;
